/**
 * Maps the body temperature to a color
 * @param type the body temperature in Celsius (float)
 * @returns the color according to the body temperature
 */
export function useBodyTemperatureColor(bodyTemperature: number): 'success' | 'error' | 'warning' | 'info' {
  if (32 <= bodyTemperature && bodyTemperature <= 38) return 'success';
  return 'error';
}
